import store from '@/app/store'
import config from '@/app/config/vuex-store'
import AuthResponse from '@/users/responses/auth-response'
import RefreshResponse from '@/users/responses/refresh-response'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

// TODO: store parameter wird ignoriert.
@Module({ store, name: 'AuthModule' })
export default class AuthModule extends VuexModule {

  public auth: AuthResponse = new AuthResponse()

  get authenticated(): boolean {
    return this.auth.authenticated
  }

  get token(): string {
    return this.auth.token || ''
  }

  get refreshToken(): string {
    return this.auth.refreshToken || ''
  }

  get tenant(): string {
    return this.auth.tenantId || ''
  }

  get roles(): string[] {
    return this.auth.roles
  }

  get displayName(): string {
    return this.auth.email
  }

  @Mutation
  public login(auth: AuthResponse) {
    this.auth = auth
  }

  @Mutation
  public refresh(response: RefreshResponse) {
    this.auth.token = response.token
    this.auth.refreshToken = response.refreshToken
  }

  @Mutation
  public logout() {
    this.auth = new AuthResponse()
    localStorage.removeItem(config.localStorageId)
  }
}
